import React, { useEffect, useState, useContext } from "react";
import "./VoyahTaishanFeatures.css";

import feature1 from "../../../../assets/images/voyahtaishan/exterior1.jpg";
import feature2 from "../../../../assets/images/voyahtaishan/exterior3.jpg";
import feature3 from "../../../../assets/images/voyahtaishan/interior1.png";
import feature4 from "../../../../assets/images/voyahtaishan/interior3.png";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const HARDCODED_MEDIA = [feature1, feature2, feature3, feature4];

const buildFeatureItems = (features, featureTabs) => {
  const items = [];

  for (let n = 1; n <= 20; n += 1) {
    const title =
      featureTabs?.[`tab_${n}`] || features?.[`feature_${n}_title`];
    if (!title) break;

    items.push({
      title,
      media: HARDCODED_MEDIA[(n - 1) % HARDCODED_MEDIA.length],
    });
  }

  return items;
};

const VoyahTaishanFeatures = () => {
  const { currentLang } = useContext(LanguageContext);

  const [features, setFeatures] = useState(null);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFeatures = async () => {
      try {
        setLoading(true);

        const response = await getPageContent("voyahtaishan", currentLang);
        const sections = response.sections || {};
        const items = buildFeatureItems(
          sections.features,
          sections.feature_tabs
        );

        setFeatures({
          title: sections.features?.features_title || "Features",
          items,
        });
      } catch (err) {
        console.error("Failed to load Voyah Taishan features", err);
      } finally {
        setLoading(false);
      }
    };

    loadFeatures();
  }, [currentLang]);

  if (loading || !features || features.items.length === 0) return null;

  const current = features.items[active];

  return (
    <section className="vt-features">
      <h2 className="vt-features-title">{features.title}</h2>
      <span className="vt-features-line" />

      <div className="vt-features-tabs">
        {features.items.map((item, index) => (
          <div
            key={index}
            className={`vt-feature-tab ${active === index ? "active" : ""}`}
            onClick={() => setActive(index)}
          >
            <p>{item.title}</p>
          </div>
        ))}
      </div>

      <div className="vt-features-media">
        <img
          key={active}
          src={current.media}
          alt={current.title}
          className="vt-features-media-image"
        />
      </div>
    </section>
  );
};

export default VoyahTaishanFeatures;
